import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DocumentsFilter } from '../documents-page.types';
import { DEFAULT_FILTER } from '../documents-page.config';
import { DocumentModel, DocumentTypesKeys } from '../../../../core/modules/documents/documents.types';

@Injectable({
  providedIn: 'root',
})

export class DocumentsFilterService {
  private readonly documentsFilter$ = new BehaviorSubject<DocumentsFilter>(DEFAULT_FILTER);
  getFilteredDocuments(documents: DocumentModel[], documentsFilter: DocumentsFilter): DocumentModel[] {
    if (
      documentsFilter.kkmId
      && documentsFilter.documentType
      && documentsFilter.documentType.length > 0) {
      return this.getDocumentsByParameters(documents, documentsFilter.kkmId, documentsFilter.documentType);
    }
    if (
      documentsFilter.kkmId
      && (!documentsFilter.documentType || documentsFilter.documentType.length === 0)
    ) {
      return this.getDocumentsByKkmId(documents, documentsFilter.kkmId);
    }
    if (
      !documentsFilter.kkmId
      && documentsFilter.documentType
      && documentsFilter.documentType.length > 0
    ) {
      return this.getDocumentsByType(documents, documentsFilter.documentType);
    }
    return documents;
  }

  getDocumentsFilter(): Observable<DocumentsFilter> {
    return this.documentsFilter$.asObservable();
  }

  setDocumentsFilter(value: DocumentsFilter): void {
    this.documentsFilter$.next(value);
  }

  resetDocumentsFilter(): void {
    this.documentsFilter$.next(DEFAULT_FILTER);
  }

  private getDocumentsByKkmId(documents: DocumentModel[], kkmId: string): DocumentModel[] {
    return documents.filter(document => String(document.kkms[0]?.id) === kkmId);
    /* return this.httpClient.get(`/api/kkms/${kkmId}/documents`) */
  }

  private getDocumentsByType(documents: DocumentModel[], selectedTypes: DocumentTypesKeys[]): DocumentModel[] {
    return documents.filter(document => selectedTypes.includes(document.docType));
    // если делать через запрос то нету возможности поиска массива типов документов только возможен поиск одного типа документа
    /* const params = new HttpParams().set('docType', type);
    return this.httpClient.get('/api/organisation/documents', {
      params,
    }); */
  }

  private getDocumentsByParameters(documents: DocumentModel[], kkmId: string, selectedTypes: DocumentTypesKeys[]): DocumentModel[] {
    return documents.filter(document => String(document.kkms[0]?.id) === kkmId
      && selectedTypes.includes(document.docType));
    /* const params = new HttpParams().set('docType', type);
    return this.httpClient.get(`/api/kkms/${kkmId}/documents`, {
      params,
    }); */
  }
}
